import { Component } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
    selector: "app-loading",
    template: `<mat-spinner></mat-spinner>`,
    styles: [
        `
            :host {
                display: flex;
                justify-content: space-around;
            }
        `,
    ],
    imports: [
        MatProgressSpinnerModule,
    ],
})
export class LoadingComponent {}
